import * as RadioGroup from '@radix-ui/react-radio-group'
import { ComponentProps, FC, forwardRef } from 'react'
import { styled } from '../../../config'
import { Text } from '../../Text'

const Title = styled(Text, {
  color: 'inherit',
  fontWeight: 500,
  fontSize: '$14'
})

const Subtitle = styled(Text, {
  color: 'inherit',
  opacity: 0.5,
  fontSize: '$12',
  paddingTop: '4px',
  variants: {
    noPadding: { true: { paddingTop: 0 } }
  }
})

const StyledButton = styled(RadioGroup.Item, {
  fontFamily: 'inherit',
  cursor: 'pointer',
  flex: '1',
  borderRadius: '12px',
  height: '68px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: '$whiteA050',
  border: '1px solid transparent',
  color: '#FFFFFF',
  transition: '150ms',
  '&:hover': {
    background: '$whiteA100'
  },
  '&:disabled': {
    cursor: 'default',
    filter: 'brightness(60%)',
    background: '$whiteA050'
  },
  '&[data-state="checked"]': {
    color: '$black',
    background: '$white'
  },
  variants: {
    active: {
      true: {
        background: '$white',
        color: '$black'
      }
    },
    outline: {
      true: {
        '&[data-state="checked"]': {
          color: '#FFFFFF',
          border: '1px solid $whiteA500',
          background: '$whiteA050'
        }
      }
    }
  }
})

type ButtonProps = {
  text?: string
  subtext?: string
} & ComponentProps<typeof StyledButton>

export const Button: FC<ButtonProps> = forwardRef(({ text, subtext, children, ...props }, ref) => {
  return (
    <StyledButton {...props} ref={ref}>
      {text && <Title>{text}</Title>}
      {subtext && <Subtitle noPadding={!text}>{subtext}</Subtitle>}
      {children}
    </StyledButton>
  )
})
